import { catchError, of, take } from 'rxjs';
import { identity, map, pickBy } from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { ChangeDetectorRef, Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';

import { LandingPagesType } from '@sifca-monorepo/ecommerce-generator';
import { LandingPagesService, SeoService, SharedService } from '../../services';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  template: '',
})
export class BaseProjectDetailsComponent {
  seo: any;
  url: string;
  page: LandingPagesType;
  posId: string = '';
  constructor(
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected seoService: SeoService,
    protected titleTagService: Title,
    protected sharedService: SharedService,
    protected activatedRoute: ActivatedRoute,
    protected changeDetectorRef: ChangeDetectorRef,
    protected landingPagesService: LandingPagesService,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.landingPagesService.getPagesByURL(this.posId, this.activatedRoute.snapshot.url[0].path).subscribe((result) => {
      this.page = result;
      this.seoService
        .getPagesSEOJSON(this.page.id)
        .pipe(
          take(1),
          catchError(() => {
            return of(null);
          }),
        )
        .subscribe((res) => {
          this.seo = res;
          if (this.seo?.title) {
            this.titleTagService.setTitle(this.seo?.title);
          }
          this.sharedService.tags$ = [
            ...this.metaTagService.addTags(map(this.seo?.metas, (meta) => pickBy(meta, identity))),
            { charset: 'UTF-8' },
          ];
          if (isPlatformBrowser(this.platformId)) {
            this.sharedService.links$ = map(this.seo?.links, (seoLink) => {
              const link = this.renderer.createElement('link');
              if (seoLink.sizes) {
                link.sizes = seoLink.sizes;
              }
              if (seoLink.href) {
                link.href = seoLink.href;
              }
              if (seoLink.rel) {
                link.rel = seoLink.rel;
              }
              this.renderer.appendChild(this.document.head, link);
              return link;
            });
          }
        });
      this.changeDetectorRef.markForCheck();
    });
  }
}
